// CLARTEXT · Abschlussseite 2.0 · UI-V1
// Statische Vergleichsdaten des HTML-Prototyps
// (/app/frontend/public/abschluss-prototyp-v2.html).
//
// WICHTIG (UI-V1): Diese Werte sind KEINE neue fachliche Wahrheit — sie sind
// eine Kopie der bestehenden Designreferenz für den pixelgetreuen Nachbau.
// Die spätere Kataloganbindung erfolgt erst in UI-V2.
export const WERK_CHIPS = [
  "Gefährdungsbeurteilung",
  "Betriebsanweisung",
  "Unterweisungstext mit Verständnisfragen",
  "Lehrbilder",
  "Prüf- und Wartungshinweise",
  "Wiederholungszyklen",
];

// Reihenfolge: HEUTE → MORGEN → NEUE MITARBEITER → ÄNDERUNGEN → PRÜFUNG → NÄCHSTES JAHR.
// Jede Gruppe enthält beliebig viele Zeilen. Jede Zeile hat drei Textzellen:
// label = linke Spalte (grauer Label-Bereich), self = mittlere Spalte
// (Einmalkauf, Selbstorganisation), clr = rechte Spalte (CLARTEXT).
// `self.isDash === true` rendert das „—" mit .dash-Style. Ansonsten mit
// Häkchen und `.ok`-Text.
export const VERGLEICHSGRUPPEN = [
  {
    nr: "HEUTE",
    titel: "Ihre fertige Dokumentation",
    zeilen: [
      {
        label: "Vollständige Arbeitsschutzmappe",
        self: {
          text: "Sie erhalten Ihre Mappe als PDF — zusätzlich senden wir sie Ihnen per E-Mail.",
        },
        clr: {
          text: "Ihre Mappe liegt vollständig in Ihrem Zugang bereit — jederzeit griffbereit.",
        },
      },
    ],
  },
  {
    nr: "MORGEN",
    titel: "Was passiert morgen?",
    zeilen: [
      {
        label: "Dokument erneut öffnen",
        self: {
          plain:
            "Ihr PDF liegt bei Ihnen — Sie drucken es, legen es ab und arbeiten damit in Eigenregie.",
        },
        clr: {
          text: "Sie öffnen Ihre Dokumentation jederzeit wieder in Ihrem Zugang.",
        },
      },
      {
        label: "Aushang für den Betrieb",
        self: { plain: "Einen Aushang gestalten Sie bei Bedarf selbst." },
        clr: {
          text: "Zu jeder Dokumentation gibt es eine druckbare Plakatansicht für den Aushang.",
        },
      },
    ],
  },
  {
    nr: "NEUE MITARBEITER",
    titel: "Was passiert, wenn neue Mitarbeiter anfangen?",
    zeilen: [
      {
        label: "Mitarbeiter verwalten",
        self: { plain: "Sie führen selbst eine Liste, wer wann unterwiesen wurde." },
        clr: {
          text: "Sie legen Ihre Beschäftigten an und haben alle an einem Ort im Blick.",
        },
      },
      {
        label: "Unterweisung durchführen",
        self: {
          plain:
            "Sie unterweisen jeden neuen Mitarbeiter persönlich und in Eigenregie.",
        },
        clr: {
          text: "Ihre Beschäftigten werden digital unterwiesen — mit Verständnisfragen am Ende.",
        },
      },
      {
        label: "Eigener Zugang für Ihre Beschäftigten",
        self: {
          isDash: true,
          plain: "Entfällt, die Unterweisung organisieren Sie persönlich.",
        },
        clr: {
          text: "Jeder Mitarbeiter erhält einen einfachen PIN-Zugang und erledigt seine Unterweisung selbst.",
        },
      },
      {
        label: "Unterweisung in der Sprache des Mitarbeiters",
        self: { plain: "Bei Bedarf übersetzen und erklären Sie selbst." },
        clr: {
          text: "Die Anzeige im Mitarbeiter-Zugang gibt es in 7 Sprachen — die Dokumente selbst bleiben deutsch.",
        },
      },
      {
        label: "Unterweisungsnachweise",
        self: {
          plain: "Sie erstellen die Nachweise selbst und heften sie in Ihrer Ablage ab.",
        },
        clr: {
          text: "Nachweise entstehen automatisch beim Abschluss jeder Unterweisung.",
        },
      },
    ],
  },
  {
    nr: "ÄNDERUNGEN",
    titel: "Was passiert, wenn sich etwas ändert?",
    zeilen: [
      {
        label: "Dokument bearbeiten & speichern",
        self: {
          plain:
            "Sie arbeiten Änderungen selbst ein und aktualisieren Ihr Dokument in Eigenregie.",
        },
        clr: {
          text: "Sie bearbeiten Ihre Dokumentation direkt und speichern die Änderung — fertig.",
        },
      },
      {
        label: "Weitere Dokumentationen",
        self: { isDash: true, plain: "Ihr Kauf umfasst genau dieses eine Dokument." },
        clr: {
          text: "Sie erstellen jederzeit neue Dokumentationen und verwalten alle an einem Ort.",
        },
      },
      {
        label: "Wirksamkeit von Maßnahmen dokumentieren",
        self: {
          plain:
            "Sie prüfen selbst, ob Ihre Maßnahmen wirken, und halten das Ergebnis fest.",
        },
        clr: {
          text: "Wirksamkeitskontrollen werden erstellt, versiegelt und bei Abweichung zur Nachkontrolle wiedervorgelegt.",
        },
      },
    ],
  },
  {
    nr: "PRÜFUNG",
    titel: "Was passiert bei einer Prüfung?",
    zeilen: [
      {
        label: "Prüfmappe mit allen Nachweisen",
        self: {
          plain:
            "Sie stellen Unterlagen und Nachweise für die Prüfung selbst zusammen.",
        },
        clr: {
          text: "Ihre Prüfmappe ist jederzeit abrufbar — auf Wunsch als gebündeltes Prüfpaket.",
        },
      },
      {
        label: "Unveränderliche Archivierung",
        self: { plain: "Ihre Ablage organisieren und sichern Sie selbst." },
        clr: {
          text: "Alle Nachweise werden unveränderlich archiviert — nachträgliches Ändern ist ausgeschlossen.",
        },
      },
    ],
  },
  {
    nr: "NÄCHSTES JAHR",
    titel: "Was passiert nächstes Jahr?",
    zeilen: [
      {
        label: "Fälligkeiten im Blick",
        self: {
          plain:
            "Sie behalten die Termine aus Ihren Wiederholungszyklen selbst im Blick.",
        },
        clr: {
          text: "Sie sehen auf einen Blick, was offen, bald fällig oder überfällig ist.",
        },
      },
      {
        label: "Wiederholungs-Unterweisungen",
        self: {
          plain: "Sie organisieren die Wiederholungen selbst und unterweisen erneut.",
        },
        clr: {
          text: "Wiederkehrende Unterweisungen werden erneut zugewiesen und abgeschlossen — mit neuem Nachweis.",
        },
      },
    ],
  },
];

// Konstanten des Prototyps (KEINE Businessdaten — nur Design-Kopie).
export const PREIS_DE = "9,90\u00a0€";
export const PREIS_SUFFIX_KOPF = "Einmaliger Kauf · 9,90\u00a0€ zzgl.\u00a0USt.";
export const PREIS_SUFFIX_FUSS = "Einmaliger Kauf · 9,90\u00a0€ zzgl.\u00a0USt.";
export const TRIAL_META_KOPF =
  "Voller Funktionsumfang · ohne Zahlungsdaten · endet automatisch";
export const TRIAL_META_FUSS = "Ohne Zahlungsdaten · endet automatisch";
export const CTA_KAUF_LABEL = "Arbeitsschutzmappe herunterladen";
export const CTA_TRIAL_LABEL = "14 Tage kostenlos kennenlernen";

// ---------------------------------------------------------------------------
// UI-V3 (Sep 2026) — Entscheidungskarten statt Vergleichstabelle.
// Copy stammt 1:1 aus dem verbindlichen Betreiber-Mockup
// (landingpage_mockup_v2.html); Detailpunkte der Karten werden aus den oben
// stehenden, fachlich freigegebenen VERGLEICHSGRUPPEN gespeist.
// ---------------------------------------------------------------------------
// B1 (Juni 2026): kurze, ruhige Überleitung statt Verkaufsfrage.
export const FORK_INTRO_TITEL = "Wie möchten Sie weitermachen?";
export const FORK_INTRO_TEXT =
  "Sie haben die freie Wahl — beide Wege starten mit Ihrer fertigen Dokumentation.";

export const DOOR_DOWNLOAD = {
  eyebrow: "WEG 1 — SIE ORGANISIEREN",
  titel: "Einmaliger Download",
  emotion:
    "Ihre kompletten Unterlagen für die Berufsgenossenschaft — sofort als " +
    "PDF. Alles Weitere, wie neue Mitarbeiter oder jährliche Wiederholungen, " +
    "organisieren Sie in Eigenregie.",
  // Erklärsatz entfällt (Betreiber-Freigabe 09.09.): Inhalt geht im
  // Kernsatz auf, sonst doppelte „…organisieren Sie in Eigenregie"-Zeile.
};
// Karte 1: Akkordeon-Punkte (Betreiber-Copy 09.09.) — ersetzen die alte
// Selbstorganisations-Spalte der Vergleichstabelle. Zwei Punkte entfielen
// ersatzlos („Eigener Zugang…" negativ formuliert, „Weitere Dokumentationen…"
// doppelt zum Preis-Hinweis).
export const DOOR_DOWNLOAD_PUNKTE = [
  { label: "Vollständige Unterlagen", text: "Sie erhalten alles als PDF, zusätzlich per E-Mail zugestellt" },
  { label: "Jederzeit griffbereit", text: "Ihr PDF liegt bei Ihnen — drucken, ablegen, im Alltag nutzen" },
  { label: "Aushang selbst gestalten", text: "Bei Bedarf erstellen Sie den Betriebsaushang eigenständig" },
  { label: "Neue Mitarbeiter", text: "Sie unterweisen persönlich und dokumentieren das selbst" },
  { label: "Änderungen", text: "Sie aktualisieren Ihr Dokument in Eigenregie, wenn sich etwas ändert" },
  { label: "Nachweise", text: "Sie erstellen und verwalten die Unterweisungsnachweise selbst" },
  { label: "Wirksamkeit prüfen", text: "Sie kontrollieren selbst, ob Ihre Maßnahmen wirken, und halten das Ergebnis fest" },
  { label: "Prüfung durch die Berufsgenossenschaft", text: "Sie stellen Unterlagen und Nachweise selbst zusammen" },
  { label: "Archivierung", text: "Ihre Ablage organisieren und sichern Sie eigenständig" },
  { label: "Fristen", text: "Sie behalten Fälligkeiten und Wiederholungen selbst im Blick" },
];
export const DOOR_TRIAL = {
  eyebrow: "WEG 2 — CLartext ÜBERNIMMT",
  titel: "Endlich Kopf frei",
  emotion:
    "Komplett automatisiert: Unterweisungen laufen von selbst, neue " +
    "Mitarbeiter per Knopfdruck dazu. Jährliche Wiederholungen laufen " +
    "automatisch. Als Browser-App für jeden Mitarbeiter rund um die Uhr " +
    "griffbereit.",
  sub:
    "Gefährdungsbeurteilungen, Betriebsanweisungen und Unterweisungen sind " +
    "im Abo enthalten — genau wie alles andere, was Ihr Betrieb dafür braucht.",
};
// Karte 2: direkt sichtbare Punkte (kein Akkordeon) — Betreiber-Copy 09.09.
export const DOOR_TRIAL_PUNKTE = [
  "Alle Mitarbeiter automatisch unterwiesen, neue per Knopfdruck",
  "Jährliche Wiederholungen laufen automatisch, ohne dass Sie dran denken müssen",
  "Jeder Mitarbeiter hat rund um die Uhr Zugriff — als Browser-App, ohne Installation",
  "Fälligkeiten und Fristen sehen Sie auf einen Blick",
  "Prüfmappe für die Berufsgenossenschaft jederzeit fertig",
  "Aushangpflichtige Gesetze immer aktuell",
  "Alles unveränderbar archiviert, jederzeit nachweisbar",
];
export const DETAILS_TOGGLE_LABEL = "Was das konkret heißt";

// B1 (Juni 2026): Kurzfassung der Abo-Tür auf der verkürzten Abschlussseite.
// Die ausführliche Erklärung (Emotion/Sub/7-Punkte/Module/Abo-Preis) wandert
// auf die neue Seite /abo (Phase B2). Alt-Konstanten bleiben für /abo erhalten.
export const DOOR_TRIAL_KURZ =
  "Unterweisungen, Aufgaben, Nachweise und Mitarbeiterzugang — alles an einem Ort.";
export const CTA_ABO_LABEL = "CLartext kennenlernen";
export const TRIAL_HINT_KURZ = "14 Tage kostenlos · ohne Zahlungsdaten";

export const RISK_NOTE =
  "Keine falsche Wahl: Beide Wege beginnen mit Ihrer fertigen Mappe. Das " +
  "Kennenlernen endet von selbst — ohne automatische Verlängerung, ohne " +
  "Zahlungspflicht.";

export const MODULES_EYEBROW = "MEHR ALS EIN DOKUMENT";
export const MODULES_TITEL = "Was in Ihrem Abo steckt";
export const MODULES_TEXT =
  "Ein Abo, sechzehn Module — plus zwei Spezialbereiche, die Sie in Ihrer Demo " +
  "direkt mit ausprobieren können.";
export const TRIAL_BANNER_TEXT =
  "In Ihren 14 Testtagen ist alles freigeschaltet — auch " +
  "Führerschein-Dokumentation und Gefahrstoffverzeichnis.";
export const ADDON_TAG_LABEL = "In der Demo inklusive";

// Die 16 Standardmodule (10 aus der Produkt-Forensik vom 07.09.2026 /
// Betreiber-Mockup + 6 vom Betreiber im Juni 2026 ergänzte) plus die 2 Add-ons.
export const MODULE_KACHELN = [
  { slug: "ki", titel: "KI-Dokumenterstellung", text: "Tätigkeit eingeben, den Rest übernimmt CLartext." },
  { slug: "gb", titel: "Gefährdungsbeurteilungen", text: "Fertig formuliert statt leeres Formular." },
  { slug: "ba", titel: "Betriebsanweisungen", text: "Druckfertiger Aushang je Tätigkeit." },
  { slug: "uw", titel: "Unterweisungen", text: "Verständlich, am Handy durchführbar." },
  { slug: "wk", titel: "Wirksamkeitskontrollen", text: "Prüft, ob Maßnahmen im Alltag wirken." },
  { slug: "bg", titel: "BG-Prüfmappe", text: "Komplettes Prüfpaket auf Knopfdruck." },
  { slug: "ma", titel: "Mitarbeiter-Portal", text: "Eigener PIN-Zugang für jeden Mitarbeiter." },
  { slug: "sprachen", titel: "Mehrsprachigkeit", text: "Komplette Inhalte in bis zu 9 Sprachen — KI-übersetzt, je nach Buchung." },
  { slug: "worm", titel: "Prüfsichere Archivierung", text: "Unveränderbar dokumentiert, dauerhaft nachweisbar." },
  { slug: "aushang", titel: "Aushangpflichtige Gesetze", text: "Immer aktuell, fertig zum Aushängen." },
  { slug: "lernhilfen", titel: "Visuelle Lernhilfen", text: "Bebilderte Lehrmaterialien statt reiner Fließtext." },
  { slug: "bibliothek", titel: "Wissensbibliothek", text: "Nachschlagewerk für alle Mitarbeiter, jederzeit griffbereit." },
  { slug: "plakate", titel: "Plakate zum Aushängen", text: "Druckfertiges Plakat mit QR-Code für jede Welt." },
  { slug: "erinnerung", titel: "Automatische Erinnerung", text: "Mitarbeiter werden per E-Mail an offene Unterweisungen erinnert." },
  { slug: "hautschutz", titel: "Hautschutzplan", text: "Passendes Hautschutzpräparat je Tätigkeit, automatisch erstellt." },
  { slug: "handschutz", titel: "Handschutzplan", text: "Passende Schutzhandschuhe je Tätigkeit, automatisch zugeordnet." },
  { slug: "fuehrerschein", titel: "Führerscheinkontrolle", text: "Fahrerlaubnisse automatisch geprüft, Fristen im Blick.", addon: true },
  { slug: "gefahrstoffe", titel: "Gefahrstoffverzeichnis", text: "Sicherheitsdatenblätter, Einstufung — automatisch gepflegt.", addon: true },
];

export const FINAL_CTA_TITEL = "Beide Wege beginnen mit Ihrer fertigen Mappe.";
export const CTA_KAUF_FINAL_PREFIX = "Einmalig herunterladen";
